import { Box, Button, CircularProgress } from '@mui/material';
import { memo } from 'react';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../../modules/translation/TranslationContext';
import { HideColumnsTestIds } from '../../../../utils/testIds/HideColumns.testIds';
import useWidth from '../../../Hooks/useWidth';
import { SavableHideableColumnsVisibilityFooterProps } from './savableHideableColumnsVisibilityFooter.types';

const SavableHideableColumnsVisibilityFooter = ({
  isSavingColumns,
  canRestoreToDefaultColumns,
  canSaveColumns,
  onRestoreToDefaultColumns,
  onSaveColumns,
}: SavableHideableColumnsVisibilityFooterProps) => {
  const { translate } = useTranslation();
  const { mobileWidth } = useWidth();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        columnGap: '8px',
      }}
    >
      <Button
        size={mobileWidth ? 'large' : 'medium'}
        fullWidth
        onClick={onRestoreToDefaultColumns}
        disabled={!canRestoreToDefaultColumns}
        test-id={HideColumnsTestIds.RESTORE_BUTTON}
      >
        {translate(LangEnum.GLOBAL_RESTORE)}
      </Button>
      <Button
        size={mobileWidth ? 'large' : 'medium'}
        color="primary"
        fullWidth
        variant="contained"
        onClick={onSaveColumns}
        disabled={!canSaveColumns}
        endIcon={isSavingColumns && <CircularProgress size={16} />}
        test-id={HideColumnsTestIds.SAVE_BUTTON}
      >
        {translate(LangEnum.GLOBAL_APPLY)}
      </Button>
    </Box>
  );
};

export default memo(SavableHideableColumnsVisibilityFooter);
